/* GA4 analytics — thin wrapper around gtag.
 * Loads gtag.js dynamically when REACT_APP_GA4_MEASUREMENT_ID is set,
 * otherwise no-ops. SPA-safe: we disable gtag's auto page_view and fire
 * page_view manually from V4Wrapper on internal nav/persona changes.
 */

const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
let initialized = false;

export const isEnabled = () => Boolean(GA_ID);

export function initGA() {
  if (initialized || !GA_ID || typeof window === 'undefined') return;
  initialized = true;

  // Inject gtag.js
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  // Bootstrap dataLayer + gtag
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  // send_page_view=false — we'll fire page_view manually per route/state change
  window.gtag('config', GA_ID, { send_page_view: false });
}

export function trackPageView({ path, title } = {}) {
  if (!GA_ID || typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', 'page_view', {
    page_path: path || window.location.pathname,
    page_title: title || document.title,
    page_location: window.location.href,
  });
}

export function trackEvent(name, params = {}) {
  if (!GA_ID || typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', name, params);
}
